module.exports = __webpack_public_path__ + "static/12-a87518744996ea23cda5f0e49af158b4.jpg";